import React, {useState, useEffect, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import Compress from "react-image-file-resizer";

function Profile() {

  const [user, setUser] = useState({})
  const [countryInfo, setCountryInfo] = useState({})
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [tiposIds, setTiposIds] = useState([]);
  const [btnMessage, setBtnMessage] = useState("Actualizar");
  const tiposEmpresa = ["Jurídica", "Natural"]
  const [userInfo, setUserInfo] = useState({
    nombre: "",
    nombreComercial: "",
    email: "",
    direccion: "",
    identificacion: "",
    tipoEmpresa: "",
    emailCorporativo: "",
    tipoAliado: "",
    pais: "",
  })

  const hiddenFileInput = React.useRef(null);

  const [file, setFile] = useState(null);
  const [url, setURL] = useState("");
  const [src, setImg] = useState('');

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  async function handleChange(e) {
    var file = e.target.files[0]
    Compress.imageFileResizer(
      file,
      600,
      300,
      "JPEG",
      10,
      0,
      (uri) => {
        setFile(uri)
        console.log(uri)
      },
      "file",
      600,
      300
    )
    setImg(URL.createObjectURL(file))
  }

  const getCountryInfo = async(pais) => {
    try {
      await firebase.db.collection("Ciudades").doc(pais).get().then((val)=>{
        setCountryInfo(val.data())
        // setTiposIds(user.tipoEmpresa === "Natural" ? val.data().idPersonaNatural : val.data().idPersonaJuridica)
      })
    } catch (e) {
      console.log("Error: " + e)
    }
  }

  const SuccessComponent = ({msg}) => {
    return (
        <div className="success-alert">
            <span className="material-icons mr-2">done</span>
            {msg}
            <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
        </div>
    )
  }

	useEffect(() => {
    firebase.getCurrentUser().then((val)=>{
      setUser(val)
      getCountryInfo(val.pais)
    })
	}, [])

    return (

        <div className="main-content-container container-fluid px-4">
          {success && <SuccessComponent msg={successMsg === "" ? "Perfil actualizado exitosamente" : successMsg}/>}
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="ml-2 col row">
                    <p className="page-title bold"><span>Mi cuenta</span><Link className="page-title light ml-3" to="/bank">Datos Bancarios</Link><Link className="page-title light ml-3" to="/petpoints">Pet Points</Link></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around">
                  <i className="material-icons color-white display-5">help_outline</i>
                </div>
              </div>
            </div>
            {user ?
            <div className="container">
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <input type="file"
                    ref={hiddenFileInput}
                    onChange={handleChange} 
                    style={{display: 'none'}}
                  />
                  
                  <img onClick={handleClick} className="cursor-pointer" src={src !== "" ? src : user.avatar} alt="" width="150" height="150" />
                </div>
                <div className="col-md-10 col-sm-12">

                  <div className="row align-items-center mb-4">  
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Nombre completo</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <input value={userInfo.nombre} placeholder={user.nombre} onChange={(e)=>{setUserInfo({...userInfo, nombre: e.target.value})}} type="text" className="form-control"/>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Nombre comercial</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <input value={userInfo.nombreComercial} placeholder={user.nombreComercial} onChange={(e)=>{setUserInfo({...userInfo, nombreComercial: e.target.value})}} type="text" className="form-control"/>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Correo electrónico</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <p className="my-0">{user.email}</p>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Dirección</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <input value={userInfo.direccion} placeholder={user.direccion} onChange={(e)=>{setUserInfo({...userInfo, direccion: e.target.value})}} type="text" className="form-control"/>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Email Corporativo</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <input value={userInfo.emailCorporativo} placeholder={user.emailCorporativo} onChange={(e)=>{setUserInfo({...userInfo, emailCorporativo: e.target.value})}} type="email" className="form-control"/>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Identificación</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      {/* <div className="row no-gutters align-items-center justify-content-spacebetween">
                        <select className="col-lg-5 form-control">
                          <option value="1">1</option>
                          {tiposIds.map((v, i)=>{
                            return (
                              <option value={v} key={i}>{v}</option>
                            )
                          })}
                          countryInfo.idPersonaNatural
                          countryInfo.idPersonaJuridica
                        </select>
                      </div> */}
                        <input value={userInfo.identificacion} placeholder={user.identificacion} onChange={(e)=>{setUserInfo({...userInfo, identificacion: e.target.value})}} type="text" className="form-control"/>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Tipo empresa</p>
                    </div>
                    <select className="col-sm-12 col-md-9 form-control" value={userInfo.tipoEmpresa} onChange={(e)=>{setUserInfo({...userInfo, tipoEmpresa: e.target.value})}}>
                      <option value={user.tipoEmpresa}>{user.tipoEmpresa}</option>
                      {user.tipoEmpresa === "Jurídica" || user.tipoEmpresa === "Juridica" ? <></> : <option value="Jurídica">Jurídica</option>}
                      {user.tipoEmpresa === "Natural" ? <></> : <option value="Natural">Natural</option>}
                    </select>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">Tipo de aliado</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <p className="my-0">{user.tipoAliado}</p>                    
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0">País</p>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <p className="my-0">{user.pais}</p>
                    </div>
                  </div>
                  <div className="row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                      <p className="my-0"></p>
                    </div>
                    <div className="col-sm-12 col-md-9">                      
                      <button onClick={updateProfile} className="btn btn-primary mr-3">{btnMessage}</button>
                      <button onClick={()=>{ resetPassword() }} className="btn btn-primary">Resetear contraseña</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            : <p>Cargando</p> 
            }

          </div>
    )

    async function resetPassword() {
      try {
        await firebase.auth.sendPasswordResetEmail(user.email)
        setSuccessMsg("Un email se ha enviado a tu email para cambiar tu contraseña")
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 4000);
      }catch(e){
        console.log(e)
      }
    }

    async function updateProfile(){
        setBtnMessage("Actualizando...")

        if(file){
          try {
            await firebase.storage.ref(`/Aliados imagenes/${file.name}`).put(file)
            firebase.storage.ref("Aliados imagenes").child(file.name).getDownloadURL().then((urlI) => {
              firebase.db.collection("Aliados").doc(user.aliadoId).update({
                avatar: urlI,
                nombre: userInfo.nombre === "" ? user.nombre : userInfo.nombre ,
                nombreComercial: userInfo.nombreComercial === "" ? user.nombreComercial : userInfo.nombreComercial,
                direccion: userInfo.direccion === "" ? user.direccion : userInfo.direccion,
                identificacion: userInfo.identificacion === "" ? user.identificacion : userInfo.identificacion,
                tipoEmpresa: userInfo.tipoEmpresa === "" ? user.tipoEmpresa : userInfo.tipoEmpresa,
                emailCorporativo: user.emailCorporativo !== undefined && userInfo.emailCorporativo === "" ? user.emailCorporativo : user.emailCorporativo === undefined && userInfo.emailCorporativo === "" ? "" : userInfo.emailCorporativo,
              })
            })
          } catch (e) {
            alert(e.message)
          }
        }else{
          await firebase.db.collection("Aliados").doc(user.aliadoId).update({
            nombre: userInfo.nombre === "" ? user.nombre : userInfo.nombre ,
            nombreComercial: userInfo.nombreComercial === "" ? user.nombreComercial : userInfo.nombreComercial,
            direccion: userInfo.direccion === "" ? user.direccion : userInfo.direccion,
            identificacion: userInfo.identificacion === "" ? user.identificacion : userInfo.identificacion,
            tipoEmpresa: userInfo.tipoEmpresa === "" ? user.tipoEmpresa : userInfo.tipoEmpresa,
            emailCorporativo: user.emailCorporativo !== undefined && userInfo.emailCorporativo === "" ? user.emailCorporativo : user.emailCorporativo === undefined && userInfo.emailCorporativo === "" ? "" : userInfo.emailCorporativo,
          })
        }

        setBtnMessage("Actualizar")
        setSuccessMsg("Perfil actualizado exitosamente")
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 4000);
    }

}

export default Profile
